import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BottomArrowSvg from '@/assets/bottom-arrow.svg';

// Components
import BaseSelect from 'vue-select';

// Other
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'VSelect',
  setup(__props) {

// Svg
const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseSelect), _mergeProps(_ctx.$attrs, { autocomplete: "off" }), _createSlots({
    "no-options": _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('no-options')), 1)
    ]),
    "open-indicator": _withCtx(({ attributes }) => [
      _createVNode(_unref(BottomArrowSvg), _normalizeProps(_guardReactiveProps(attributes)), {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("^")
        ])),
        _: 2
      }, 1040)
    ]),
    _: 2
  }, [
    _renderList(_ctx.$slots, (_, slot) => {
      return {
        name: slot,
        fn: _withCtx((scope) => [
          _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope)))
        ])
      }
    })
  ]), 1040))
}
}

})